exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-5c465d60]{z-index:333 !important}.flex-center[data-v-5c465d60]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.selWidth[data-v-5c465d60]{width:320px}", ""]);

// exports
